import { render } from "./PrivacyPopup.vue?vue&type=template&id=f99a6a20&scoped=true"
import script from "./PrivacyPopup.vue?vue&type=script&lang=js"
export * from "./PrivacyPopup.vue?vue&type=script&lang=js"

import "./PrivacyPopup.vue?vue&type=style&index=0&id=f99a6a20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99a6a20"]])

export default __exports__